/* UnboxTCG — card page shelves (owner, 2026-10-23: "build it as shown", the mockup of 2026-10-22).
 *
 * A card page used to end on a wall: the card, its rules, a block of text links. Now it ends on shelves of pictures,
 * each a way further into the store: more cards from this set (and the whole set's gallery), the sealed products
 * this card comes in, the Hot row, and what to read next. The data is ubx-shelf-<k>.json, written nightly by
 * src/catalog/export-shelves.ts; k is the set code's character codes summed, mod the number of files.
 *
 * Order on the page: set, sealed and Hot go before #ubx-c2-alts (where ubx-alts.js puts "Does the same job"), and
 * Read next right after it, so the alternatives row lands between them whenever it arrives. No data, no shelf.
 *
 * "In N precons" (owner, 2026-10-29: the precon lists should be "easy to find ... when a user is on a card") sits after
 * "Open it yourself": the precons holding this card, best value first, from ubx-precon-cards-<k>.json and
 * ubx-precon-decks.json, which src/tools/deck-lists.mjs writes nightly. Magic only.
 *
 * Pokémon card pages (owner, 2026-10-24: "add shelves to the pokemon card pages too") read the same files, under "pk"
 * by set id, placed by the sum of "PK-" + the id. They have no alternatives row and no "Comes in", so the shelves go at
 * the end of the card and "Open it yourself" is the set's own sealed, flagship first.
 */
(function () {
  var cfg = window.__ubxShelf, holder = document.getElementById("ubx-c2-data"), main = document.getElementById("ubx-c2");
  var anchor = document.getElementById("ubx-c2-alts");
  if (!cfg || !cfg.urls || !cfg.urls.length || !holder) return;
  var data; try { data = JSON.parse(holder.textContent.trim()); } catch (e) { return; }
  var pk = data.g === "pokemon";
  if (pk ? !main : !anchor || !anchor.parentNode) return;
  var code = pk ? String(data.s || "") : String(data.s || "").toUpperCase(); if (!code) return;
  var place = pk ? "PK-" + code.toUpperCase() : code;
  var k = 0; for (var i = 0; i < place.length; i++) k += place.charCodeAt(i);
  k = k % cfg.urls.length;

  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]; }); };
  var money = function (c) { return "$" + (c / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var scry = function (id) { return "https://cards.scryfall.io/normal/front/" + id[0] + "/" + id[1] + "/" + id.slice(0, 8) + "-" + id.slice(8, 12) + "-" + id.slice(12, 16) + "-" + id.slice(16, 20) + "-" + id.slice(20) + ".jpg"; };
  var aff = window.__ubxAff || {};
  var tcgLink = function (id) { return aff.tcg ? aff.tcg + "?u=" + encodeURIComponent("https://www.tcgplayer.com/product/" + id) + "&subId1=shelf-" + id : "https://www.tcgplayer.com/product/" + id; };

  var css = document.createElement("style");
  css.textContent = [
    ".ubx-shelves{max-width:72rem;margin:2.6rem auto 0}",
    ".ubx-shelf{margin:0 0 2.6rem}",
    ".ubx-shelf-h{display:flex;flex-wrap:wrap;align-items:baseline;gap:.3rem 1rem;margin:0 0 .9rem}",
    ".ubx-shelf-h h2{font-size:1.3rem;line-height:1.25;margin:0;letter-spacing:-.01em}",
    ".ubx-shelf-h a{margin-left:auto;font-size:.95rem;color:var(--ubx-muted);text-decoration:none;white-space:nowrap}",
    ".ubx-shelf-h a:hover{color:inherit}",
    ".ubx-row{display:flex;gap:1rem;overflow-x:auto;width:0;min-width:100%;padding-bottom:.6rem;-webkit-overflow-scrolling:touch;scroll-snap-type:x proximity}",
    ".ubx-tile{flex:0 0 10.5rem;width:10.5rem;min-width:0;text-decoration:none;color:inherit;display:block;scroll-snap-align:start}",
    ".ubx-tile img{width:100%;aspect-ratio:488/680;object-fit:cover;border-radius:10px;box-shadow:0 0 0 1px var(--ubx-line);display:block;background:var(--ubx-surface-2);transition:transform .15s}",
    ".ubx-tile:hover img,.ubx-prod a.pic:hover img,.ubx-art:hover img{transform:translateY(-3px)}",
    ".ubx-tile b{display:block;font-weight:600;font-size:.95rem;line-height:1.3;margin-top:.5rem;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
    ".ubx-tile small{display:block;color:var(--ubx-muted);font-size:.82rem;margin-top:.15rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
    ".ubx-tile span{display:block;font-size:.9rem;font-weight:600;margin-top:.2rem;font-variant-numeric:tabular-nums}",
    ".ubx-tile.more{display:flex;flex-direction:column;justify-content:center;gap:.3rem;padding:1.2rem;border:1px solid var(--ubx-line);border-radius:12px;background:var(--ubx-surface-2);align-self:flex-start;aspect-ratio:488/680}",
    ".ubx-tile.more b{font-size:1.1rem;margin:0} .ubx-tile.more em{font-style:normal;font-size:1.6rem}",
    ".ubx-prods{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(13.5rem,100%),1fr));gap:1rem}",
    ".ubx-prod{border:1px solid var(--ubx-line);border-radius:14px;padding:.9rem;display:flex;flex-direction:column;gap:.25rem}",
    ".ubx-prod a.pic{display:block;color:inherit;text-decoration:none}",
    ".ubx-prod img{width:100%;aspect-ratio:1;object-fit:contain;background:#fff;border-radius:10px;margin-bottom:.5rem;transition:transform .15s}",
    ".ubx-prod b{display:block;font-weight:600;line-height:1.3} .ubx-prod small{color:var(--ubx-muted);font-size:.82rem}",
    ".ubx-prod .pr{font-size:1.1rem;font-weight:700;font-variant-numeric:tabular-nums;margin-top:.15rem}",
    ".ubx-pc-sub{margin:-.35rem 0 .9rem;color:var(--ubx-muted);font-size:.92rem}",
    ".ubx-prod .pcx{display:block;margin-top:.1rem} .ubx-prod .pcx strong{color:var(--ubx-ink);font-weight:700}",
    ".ubx-prod .go{margin-top:.55rem;text-align:center;border:1px solid currentColor;border-radius:999px;padding:.45rem .8rem;font-weight:600;font-size:.9rem;text-decoration:none;color:inherit}",
    ".ubx-arts{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(16rem,100%),1fr));gap:1.1rem}",
    ".ubx-art{display:flex;flex-direction:column;gap:.25rem;text-decoration:none;color:inherit}",
    ".ubx-art img{width:100%;aspect-ratio:16/9;object-fit:cover;border-radius:12px;transition:transform .15s}",
    ".ubx-art small{color:var(--ubx-muted);font-size:.72rem;text-transform:uppercase;letter-spacing:.07em;margin-top:.35rem}",
    ".ubx-art b{font-weight:600;line-height:1.3}",
    // "Does the same job" (ubx-alts.js) in the same voice as the shelves around it.
    "#ubx-alts-row{margin-bottom:2.6rem !important}",
    "#ubx-alts-row>h2{font-size:1.3rem !important;letter-spacing:-.01em !important;text-transform:none !important;color:inherit !important;font-weight:700 !important}"
  ].join("\n");
  document.head.appendChild(css);

  // Placeholders now, filled when the data lands: the alternatives row goes in between them whenever it arrives.
  var top = document.createElement("div"); top.className = "ubx-shelves"; top.id = "ubx-shelves";
  var bottom = document.createElement("div"); bottom.className = "ubx-shelves"; bottom.id = "ubx-read-next";
  if (pk) { main.appendChild(top); main.appendChild(bottom); }
  else { anchor.parentNode.insertBefore(top, anchor); anchor.parentNode.insertBefore(bottom, anchor.nextSibling); }
  // A Magic tile carries a Scryfall image id, a Pokémon one its image URL.
  var cardImg = function (x) { return /^https?:/.test(x) ? x : scry(x); };

  var head = function (title, href, linkText) {
    return '<div class="ubx-shelf-h"><h2>' + esc(title) + "</h2>" + (href ? '<a href="' + esc(href) + '">' + esc(linkText) + " &rarr;</a>" : "") + "</div>";
  };
  // The sealed pages this card's printings link under "Comes in", in page order.
  var comesIn = function () {
    var seen = {}, out = [];
    [].forEach.call(document.querySelectorAll('#ubx-c2 a[href*="/pages/s-"]'), function (a) {
      var h = (a.getAttribute("href") || "").split("/pages/")[1]; h = h ? h.split(/[?#]/)[0] : "";
      if (h && !seen[h]) { seen[h] = 1; out.push(h); }
    });
    return out;
  };

  // The precon shelf. k for a name is its lowercased UTF-16 codes summed, mod the file count; a double-faced card is
  // looked up whole, then by its front face. Drawn into the slot the shelves leave, whichever of the two lands last.
  var pcHtml = null, pcFill = function () { var slot = document.getElementById("ubx-pc-slot"); if (slot && pcHtml) slot.outerHTML = pcHtml; };
  var pcFind = function (names) {
    if (!names.length) return Promise.resolve(null);
    var nm = names[0], s = 0;
    for (var j = 0; j < nm.length; j++) s += nm.charCodeAt(j);
    return fetch(cfg.precon[s % cfg.precon.length]).then(function (r) { return r.ok ? r.json() : null; }).then(function (f) {
      return f && f[nm] ? f[nm] : pcFind(names.slice(1));
    });
  };
  if (!pk && cfg.precon && cfg.precon.length && cfg.preconDecks) {
    var pcName = String(data.n || "").toLowerCase();
    pcFind(pcName.indexOf(" // ") > 0 ? [pcName, pcName.split(" // ")[0]] : [pcName]).then(function (hit) {
      if (!hit) return null;
      return fetch(cfg.preconDecks).then(function (r) { return r.ok ? r.json() : null; }).then(function (decks) {
        // d = [handle, name, set, year, TCGplayer id, cards' value, deck price, multiple, top card, its cents, second card,
        // its cents]. The tile names the deck's dearest card (owner, 2026-10-30: "what card is hot inside the deck", not the
        // multiple), or the next one when the dearest is this page's own card.
        var here = pcName.split(" // ")[0];
        var topOf = function (d) { return d[8] && d[8].toLowerCase().split(" // ")[0] !== here ? [d[8], d[9]] : d[10] ? [d[10], d[11]] : null; };
        var list = decks ? hit.slice(1).map(function (id) { return decks[id]; }).filter(Boolean) : [];
        if (!list.length) return;
        pcHtml = '<section class="ubx-shelf">' + head(hit[0] > 1 ? "In " + hit[0] + " precons" : "In a precon", "/pages/precons", "Every precon")
          + (hit[0] > list.length ? '<p class="ubx-pc-sub">The ' + list.length + " best value.</p>" : "")
          + '<div class="ubx-prods">' + list.map(function (d) {
            return '<div class="ubx-prod"><a class="pic" href="/pages/' + esc(d[0]) + '">'
              + (d[4] ? '<img src="https://product-images.tcgplayer.com/fit-in/437x437/' + encodeURIComponent(d[4]) + '.jpg" alt="' + esc(d[1]) + '" loading="lazy">' : "")
              + "<b>" + esc(d[1]) + "</b><small>" + esc(d[2]) + (d[3] ? " \u00b7 " + esc(d[3]) : "") + "</small>"
              + (d[6] != null ? '<div class="pr">' + money(d[6]) + "</div>" : "")
              + (topOf(d) && topOf(d)[1] != null ? '<small class="pcx">Top card: <strong>' + esc(topOf(d)[0]) + "</strong> \u00b7 " + money(topOf(d)[1]) + "</small>" : "") + "</a>"
              + (d[4] ? '<a class="go" href="' + esc(tcgLink(d[4])) + '" target="_blank" rel="noopener sponsored">Buy on TCGplayer</a>' : '<a class="go" href="/pages/' + esc(d[0]) + '">Where to buy</a>')
              + "</div>";
          }).join("") + "</div></section>";
        pcFill();
      });
    }).catch(function () { /* no precon shelf */ });
  }

  fetch(cfg.urls[k]).then(function (r) { return r.ok ? r.json() : null; }).then(function (sh) {
    if (!sh) return;
    var set = ((pk ? sh.pk : sh.sets) || {})[code], html = "";
    if (set && set.t && set.t.length) {
      var name = String(data.n || "").toLowerCase();
      var cards = set.t.filter(function (c) { return c[0].toLowerCase() !== name; }).slice(0, 10);
      if (cards.length) {
        html += '<section class="ubx-shelf">' + head("More from " + set.n, set.h ? "/pages/" + set.h : null, "See all " + set.c)
          + '<div class="ubx-row">' + cards.map(function (c) {
            return '<a class="ubx-tile" href="/pages/' + esc(c[4]) + "#p-" + encodeURIComponent(c[1]) + '"><img src="' + esc(cardImg(c[2])) + '" alt="' + esc(c[0]) + '" loading="lazy">'
              + "<b>" + esc(c[0]) + "</b><span>" + money(c[3]) + "</span></a>";
          }).join("")
          + (set.h ? '<a class="ubx-tile more" href="/pages/' + esc(set.h) + '"><b>See all ' + esc(set.c) + " cards</b><small>dearest first</small><em>&rarr;</em></a>" : "")
          + "</div></section>";
      }
    }
    if (set && set.s && set.s.length) {
      var byHandle = {}; set.s.forEach(function (p) { byHandle[p[1]] = p; });
      // Magic: the sealed this printing comes in. Pokémon: the set's own, flagship first (the file's order).
      var prods = (pk ? set.s : comesIn().map(function (h) { return byHandle[h]; }).filter(Boolean)).slice(0, 4);
      if (prods.length) {
        html += '<section class="ubx-shelf">' + head("Open it yourself", pk ? "/pages/pokemon" : "/pages/" + prods[0][1], pk ? "All Pokémon sealed" : "Every sealed product")
          + '<div class="ubx-prods">' + prods.map(function (p) {
            return '<div class="ubx-prod"><a class="pic" href="/pages/' + esc(p[1]) + '">'
              + (p[2] ? '<img src="https://product-images.tcgplayer.com/fit-in/437x437/' + encodeURIComponent(p[2]) + '.jpg" alt="' + esc(p[0]) + '" loading="lazy">' : "")
              + "<b>" + esc(p[0]) + "</b><small>" + esc(p[4]) + "</small>" + (p[3] != null ? '<div class="pr">' + money(p[3]) + "</div>" : "") + "</a>"
              + (p[2] ? '<a class="go" href="' + esc(tcgLink(p[2])) + '" target="_blank" rel="noopener sponsored">Buy on TCGplayer</a>' : '<a class="go" href="/pages/' + esc(p[1]) + '">Where to buy</a>')
              + "</div>";
          }).join("") + "</div></section>";
      }
    }
    if (!pk) html += '<div id="ubx-pc-slot"></div>';
    var hot = ((pk ? sh.pkhot : sh.hot) || []).filter(function (c) { return String(c[0]).toLowerCase() !== String(data.n || "").toLowerCase(); }).slice(0, 10);
    if (hot.length) {
      html += '<section class="ubx-shelf">' + head("Hot right now", pk ? "/?game=pokemon" : "/?game=magic", "Everything moving")
        + '<div class="ubx-row">' + hot.map(function (c) {
          return '<a class="ubx-tile" href="' + esc(c[2]) + '"><img src="' + esc(c[3]) + '" alt="' + esc(c[0]) + '" loading="lazy">'
            + "<b>" + esc(c[0]) + "</b><small>" + esc(c[1]) + "</small><span>" + money(c[4]) + "</span></a>";
        }).join("") + "</div></section>";
    }
    top.innerHTML = html;
    pcFill();

    var reads = [].concat((set && set.a) || [], (pk ? sh.pklatest : sh.latest) || []).filter(function (a, j, all) {
      for (var x = 0; x < j; x++) if (all[x][1] === a[1]) return false;
      return true;
    }).slice(0, 3);
    if (reads.length) {
      bottom.innerHTML = '<section class="ubx-shelf">' + head("Read next", pk ? "/blogs/news/tagged/pokemon" : "/blogs/news", "All guides")
        + '<div class="ubx-arts">' + reads.map(function (a) {
          return '<a class="ubx-art" href="' + esc(a[1]) + '"><img src="' + esc(a[2]) + '" alt="" loading="lazy"><small>' + esc(a[3]) + "</small><b>" + esc(a[0]) + "</b></a>";
        }).join("") + "</div></section>";
    }
  }).catch(function () { /* no shelves is the correct failure mode */ });
})();
